import { Property } from "./interfaces";

export const fechaSuministroTecnologia: Property = {
  title: "Fecha de Suministro de Tecnología",
  type: "string",
  format: "local-date-time",
};
